import React, { useContext } from 'react';
import Collect from '@fiverr-private/collect';
import { Popover } from '@fiverr-private/fit';
import { MixpanelContext } from '../../context/MixpanelContext';
import { CollectionsContext } from '../../context/CollectionsContext';
import { TrackAction } from '../../../../../lib/mixpanel';
import type { OnCollectionClickedCallback, Resource } from '../../../../../lib/types/collections';
import { useBigQuery } from '../../BigQuery';
import type { ActionsProps } from './types';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
const BOTTOM_RIGHT: string = Popover.POSITIONS.BOTTOM_RIGHT;

export const Actions = ({ id }: ActionsProps) => {
  const bigQuery = useBigQuery();
  const trackMixpanel = useContext(MixpanelContext);
  const [collections, setCollections] = useContext(CollectionsContext);

  if (!collections) {
    return null;
  }

  const resource: Resource = { id, type: Collect.RESOURCE_TYPES.INSPIRE_DELIVERY };
  const menuPosition = BOTTOM_RIGHT;

  const onCollectionClickedCallback: OnCollectionClickedCallback = ({ isCollected: prevIsCollected }) => {
    const isCollected = !prevIsCollected;

    if (isCollected) {
      bigQuery.trackClickOnSaveDelivery();
      trackMixpanel(TrackAction.Save);
    } else {
      trackMixpanel(TrackAction.Unsave);
    }
  };

  return (
    <Collect
      inspireVariant
      collections={collections}
      resource={resource}
      showMenu
      menuPosition={menuPosition}
      onUpdateCollections={setCollections}
      onCollectionClickedCallback={onCollectionClickedCallback}
      allowMenuOverflow
    />
  );
};
